// @flow

import alt from '../alt';

class ActiveConfigActions {
	/**
	 * Algatatakse toote laadimine serverist
	 */
	fetchConfig() {
		return {};
	}
	
	/**
	 * Toote laadimine ebaõnnestus
	 */
	fetchConfigFailed(error) {
		return error;
	}
	
	/**
	 * Toode sai laetud
	 */
	fetchConfigDone(data) {
		return data;
	}
	
}

export default alt.createActions(ActiveConfigActions);
